import StandardLayout from '@/common/layouts/StandardLayout';
import { useGetTournamentSchedulesQuery } from '@/redux/api/tournaments';
import TournamentScheduleCard from '@/features/tournaments/components/TournamentScheduleCard';

const TournamentSchedulePage = () => {
  const { data: schedules = [], isLoading } = useGetTournamentSchedulesQuery();

  return (
    <StandardLayout pageTitle="Tournament Schedules">
      <div className="m-4">
        {isLoading ? (
          <div className="text-center">Loading...</div>
        ) : schedules.length === 0 ? (
          <div className="text-center">
            <p>No schedules found</p>
          </div>
        ) : (
          <div>
            {schedules.map((schedule) => (
              <TournamentScheduleCard key={schedule.id} id={schedule.id} />
            ))}
          </div>
        )}
      </div>
    </StandardLayout>
  );
};

export default TournamentSchedulePage;
